/** Remove all whitespace, including unicode spaces from rich-text paste (e.g. Notes). */
export function stripSpaces(value) {
  if (value == null) return "";
  return String(value).replace(/\s/gu, "");
}

/** Prevent the space bar from inserting whitespace into an input. */
export function blockSpaceKey(e) {
  if (e.key === " " || e.key === "Spacebar") {
    e.preventDefault();
  }
}

/**
 * Intercept paste so leading/trailing whitespace never lands in the field.
 * Browsers handle paste on type="email" differently than type="password".
 */
export function handlePasteStripSpaces(e, onValue) {
  e.preventDefault();
  const pasted = stripSpaces(e.clipboardData.getData("text/plain"));
  const input = e.target;
  const start = input.selectionStart ?? input.value.length;
  const end = input.selectionEnd ?? input.value.length;
  const next = stripSpaces(
    input.value.slice(0, start) + pasted + input.value.slice(end),
  );
  onValue(next);
}
